<template>
	<div ref="eTable">
		<Table highlight-row :columns="columns" :max-height="tableHeight||maxHeight" :data="list" disabled-hover border :loading="loading" @on-selection-change="selectChange" >
			<template v-for="(item,key) in $scopedSlots" slot-scope="{ row, index }"  :slot="key">
				<slot :name="key" :row="row" :index="index"></slot>
			</template>
		</Table>
		<div style="margin: 10px;overflow: hidden">
			<div style="float: right;">
				<Page :total="total" :current="pageParams.page" :page-size="pageParams.count" @on-change="changePage" show-total></Page>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		columns:{
			default(){
				return []
			}
		},
		url:{
			type:String,
			default:''
		},
		params:{
			default(){
				return {}
			}
		},
		onSelectionChange:{
			type:Function,
			default:function(){}
		},
		handleData:{
			type:Function,
			default:res=>{
				return res
			}
		},
		selectType:{
			type:String,
			default:''
		},
		count:{
			type:Number,
			default:10
		},
		show:{
			type: Boolean,
			default: true
		},
		autoHeight: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			list:[],
			pageParams:{
				count:this.count,
				page:1
			},
			total:0,
			loading:false,
			maxHeight: window.innerHeight > document.body.clientHeight ? 690 : 'auto',
            tableHeight:''
		}
	},
	created(){
		if(this.show){
			this.getList();
		}
	},
	mounted () {
		if (this.autoHeight) {
			this.$nextTick(() => {
				this.setMaxHeight()
			})
		}
	},
	methods:{
		// 计算并设置最大高度
		setMaxHeight () {
			let height = document.body.clientHeight - this.$refs.eTable.getBoundingClientRect().top - 90;
			if (height >= 300) {
				this.tableHeight = height
			}
		},
		getList(val){
			this.pageParams.page = val||1
			this.loading=true;
			this.$axios.post(this.url+'.all',{
				...this.pageParams,
				...this.params
			}).then(res=>{
				if(res.code==10000000){
					this.list=this.handleData(res.data);
					if (this.selectType=='trainee') { // 实习生参保人员列表批量取消续保限制
						this.list.forEach(el=>{
							if(el.isAutoRenew&&(el.insuranceStatus=='YUSHOUJIAN'||el.insuranceStatus=='CHENGBAOJIAN')){
								el._disabled = false 
							} else {
								el._disabled = true 
							}
						})
					}
					if(this.selectType=='flexible'){
						// 判断数据是否满足条件 保障状态为待生效-未作替换操作-未录入保单号
						this.list.forEach(el=>{
							if(!el.isShow){
								el._disabled = true 
							} else {
								el._disabled = false 
							}
						})
					} 
					if(this.selectType=='zhijia'){
						// 智家增减人   确认状态禁用
						this.list.forEach(el=>{
							console.log(el.status=='WAIT_CONFIRM',el.status )
							if(el.status=='WAIT_CONFIRM'){
								el._disabled = false 
							} else {
								el._disabled = true 
							}
						})
					}
					if(this.selectType=='settlement'){
						//同线工人 结算状态为1允许勾选
						this.list.forEach(el=>{
							if(el.settlementStatus == 1){
								el._disabled = false 
							} else {
								el._disabled = true 
							}
						})
					} 
					this.total=res.total;
					this.$emit('getTotal',res.total)
				}else{
					// 不是钉钉的话
					if(!navigator.userAgent.includes("DingTalk")){
						this.alert(res.msg)
					}
				}
				this.loading=false;
			}).catch(res=>{
				this.loading=false;
				// 不是钉钉的话
				if(!navigator.userAgent.includes("DingTalk")){
					this.alert('加载失败')
				}
			});
		},
		changePage(val){
			// this.pageParams.page=val;
			this.getList(val)
		},
		selectChange(val){
			this.$emit('on-selection-change',val)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/ITable.vue